import { Command } from "./Command";

export default class LinkWahooCommand extends Command {
    code: string
    saveAfterLink: boolean
    constructor(code: string, saveAfterLink = false) {
        super()
        this.code = code
        this.saveAfterLink = saveAfterLink
    }
}
